import React, { useEffect } from "react";

import Main from '../components/AccountSpecification/Main'
import Accounts from "../components/AccountSpecification/Accounts";
import Advantages from "../components/AccountSpecification/Advantages";

function AccountSpecification () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[60px]">
            <Main/>
            <Accounts/>
            <Advantages/>
        </div>
    );
}

export default AccountSpecification;